"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.Inject = core_1.Inject;
exports.Optional = core_1.Optional;
exports.Injectable = core_1.Injectable;
exports.Self = core_1.Self;
exports.SkipSelf = core_1.SkipSelf;
exports.Host = core_1.Host;
exports.forwardRef = core_1.forwardRef;
exports.resolveForwardRef = core_1.resolveForwardRef;
exports.Injector = core_1.Injector;
exports.ReflectiveInjector = core_1.ReflectiveInjector;
exports.ResolvedReflectiveFactory = core_1.ResolvedReflectiveFactory;
exports.ReflectiveKey = core_1.ReflectiveKey;
exports.InjectionToken = core_1.InjectionToken;
exports.OpaqueToken = core_1.OpaqueToken;



//////////////////
// WEBPACK FOOTER
// ./index.ts
// module id = 36
// module chunks = 0